import { render, staticRenderFns } from "./ContentTypeContact.vue?vue&type=template&id=1a4f9d70&"
import script from "./ContentTypeContact.vue?vue&type=script&lang=js&"
export * from "./ContentTypeContact.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeContact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports